import { Breadcrumb } from '@sentry/react';

export const XHR__API_CALL_TRACE_ID = (traceID: string): Breadcrumb => ({
  level: 'debug',
  category: 'traceid',
  message: traceID,
});
